import {
    Form,
    Modal,
    ModalHeader,
    ModalFooter,
    Input,
    Button,
} from "reactstrap";
import { useState, useEffect } from "react";

import dimensionLogo from "Images/Dimension_Logo_Name.png";
import styles from "Pages/Login/Login.module.css";
import useAlertContext from "Hooks/useAlertContext";

interface IProps {
    whichModalShown: whichModalShown;
    onSetWhichModalShown: Function;
}

export default function ResetPassword({
    whichModalShown,
    onSetWhichModalShown,
}: IProps) {
    const [modalShown, setModalShown] = useState(true);
    const [formData, setFormData] = useState({ userId_or_email: "" });
    const [email, setEmail] = useState("");
    const { newAlert } = useAlertContext();

    // Conditionally render the modal based on the whichModalShown state from parent Login.jsx
    useEffect(() => {
        setEmail("");
        setFormData({ userId_or_email: "" });
        whichModalShown === "resetPassword"
            ? setModalShown(true)
            : setModalShown(false);
    }, [whichModalShown]);

    // Handle this modal's toggle
    function toggleModal() {
        whichModalShown === "resetPassword"
            ? onSetWhichModalShown("")
            : onSetWhichModalShown("resetPassword");
        setModalShown((modalShown) => !modalShown);
    }

    function handleFormChange(e: React.ChangeEvent<HTMLInputElement>) {
        const name = e.target.name;
        let value = e.target.value;

        setFormData((formData) => ({ ...formData, [name]: value }));
    }

    // Post to "/api/reset_password" with formData
    async function resetPassword(e: React.FormEvent) {
        e.preventDefault();

        const response = await fetch("/api/reset_password", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();
        console.log(data);

        if (response.ok) {
            setEmail(data.email);
        } else {
            newAlert({
                color: "danger",
                message: data.detail,
            });
        }
    }

    return (
        <Modal
            className={styles.modal}
            style={{ backgroundColor: "#f5f5f5" }}
            isOpen={modalShown}
            toggle={toggleModal}
        >
            <ModalHeader
                toggle={toggleModal}
                style={{ justifyContent: "center" }}
            >
                <img
                    className={styles.dimensionLogoModal}
                    src={dimensionLogo}
                    alt="Dimension"
                />
            </ModalHeader>

            {email !== "" ? (
                <div className={styles.formSignin}>
                    <p>
                        Your password has successfully been reset. An email is
                        being sent to you at: {email}{" "}
                    </p>
                    <p>
                        Please follow the link in that email to reset your
                        password.
                    </p>
                </div>
            ) : (
                <Form className={styles.formSignin} onSubmit={resetPassword}>
                    <Input
                        value={formData.userId_or_email}
                        onChange={(e) => handleFormChange(e)}
                        name="userId_or_email"
                        className={styles.formControl}
                        type="text"
                        placeholder="Username or Email"
                        required
                    />

                    <ModalFooter>
                        <Button
                            color="primary"
                            size="lg"
                            className={styles.formControl}
                            type="submit"
                            value="Log in"
                        >
                            Reset Password
                        </Button>
                    </ModalFooter>
                </Form>
            )}
        </Modal>
    );
}
